import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { getUrl } from '../api';
import { HasClassName } from '../component-utils';
import { useSelector } from '../hook-utils';
import { Identifier } from '../model';
import './ProfilePhoto.scss';
import { selectMyself } from '../store/reducers/config';

type Props = HasClassName & {
  name: string
  extension?: Identifier
  contact?: Identifier
  clid?: string
  transparent?: boolean
  datetime?: string
  load?: boolean
}

export default function ProfilePhoto({ name, className, extension, contact, clid, transparent, datetime, load }: Props) {
  const myId = useSelector(selectMyself)
  const [error, setError] = useState(false)
  let url = profilePhoto(myId, extension, contact, clid, transparent, datetime)
  if (load === undefined || load === true) {
    if (extension) {
      url = getUrl(`/Profile?server=${encodeURIComponent(extension.server)}&id=${encodeURIComponent(extension.id)}&type=extension&d=${datetime}`)
    } else if (contact) {
      url = getUrl(`/Profile?server=${encodeURIComponent(contact.server)}&id=${encodeURIComponent(contact.id)}&type=contact&d=${datetime}`)
    } else if (clid && myId) {
      url = getUrl(`/Profile?clid=${encodeURIComponent(clid)}&server=${encodeURIComponent(myId.server)}&extension=${encodeURIComponent(myId.id)}&d=${datetime}`)
    }
  } else {
    url = ''
  }

  useEffect(() => {
    setError(false)
  }, [url])

  const onError = useCallback(() => {
    setError(true)
  }, [])

  const initials = getInitials(name) || '?'

  return <div className={classNames('ProfilePhoto', transparent && 'transparent', className)}>
    <svg viewBox='0 0 30 30'>
      <text x='50%' y='55%' dominantBaseline='middle' textAnchor='middle'>{initials}</text>
    </svg>
    {error ? null : <img alt='' src={url} onError={onError} />}
  </div>
}

function getInitials(name: string) {
  return (/(.)[^ ]+ ?(?:\(.*?\) ?)?(.)?/.exec(name) || []).slice(1).join('').toUpperCase()
}

export function profilePhoto(myId: Identifier | null, extension?: Identifier, contact?: Identifier, clid?: string, transparent?: boolean, datetime?: string) {
  let url = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  if (extension) {
    url = getUrl(`/Profile?server=${encodeURIComponent(extension.server)}&id=${encodeURIComponent(extension.id)}&type=extension&d=${datetime}`)
  } else if (contact) {
    url = getUrl(`/Profile?server=${encodeURIComponent(contact.server)}&id=${encodeURIComponent(contact.id)}&type=contact&d=${datetime}`)
  } else if (clid && myId) {
    url = getUrl(`/Profile?clid=${encodeURIComponent(clid)}&server=${encodeURIComponent(myId.server)}&extension=${encodeURIComponent(myId.id)}&d=${datetime}`)
  }
  return url
}
